import React from 'react';
import moment from 'moment';
import { ColumnsType } from 'antd/lib/table';

import { IVeiculoProps } from '../../types';
import { TableButtonDelete } from './TableButtonDelete';
import { TableButtonEdit } from './TableButtonEdit';
import { TableButtonView } from './TableButtonView';
import { TableButtonRestore } from './TableButtonRestore';

interface ITableColumnControllerProps {
  handleDeleteFunction: (veiculoId: string) => Promise<void>;
  handleRestoreFunction: (veiculoId: string) => Promise<void>;
  refetch: () => void;
  dataList?: IVeiculoProps[];
}

export function TableColumnController({
  handleDeleteFunction,
  handleRestoreFunction,
  refetch,
  dataList,
}: ITableColumnControllerProps) {
  const columns: ColumnsType<IVeiculoProps> = [
    {
      title: 'Número',
      dataIndex: 'numero',
      sorter: true,
    },

    {
      title: 'Ações',
      dataIndex: 'actions',
      render: (_, item) => {
        return (
          <div className="table-actions">
            {item.status === 0 ? (
              <TableButtonRestore handleRestoreFunction={handleRestoreFunction} contactId={String(item.id)} />
            ) : (
              <>
                <TableButtonView veiculoId={String(item.id)} refetch={refetch} data={item} />
                <TableButtonEdit veiculoId={String(item.id)} refetch={refetch} data={item} />

                <TableButtonDelete handleDeleteFunction={handleDeleteFunction} veiculoId={String(item.id)} />
              </>
            )}
          </div>
        );
      },
    },
  ];

  const data: any[] = [];

  dataList?.forEach(item => {
    data.push({
      key: item.id,
      id: item.id,
      createdAt: moment(item.createdAt).format('DD/MM/YYYY'),
      idProprietario: String(item.idProprietario),
      idOperadora: String(item.idOperadora),
      numero: item.numero,
      contrato: item.contrato,
      contratoInicio: moment(item.contratoInicio),
      contratoFim: moment(item.contratoFim),
      status: item.status,
    });
  });

  return { columns, data };
}
